import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LabPassRepositoryService } from './services/lab-pass.repository.service';
import { QuestionsFormService } from './components/form-questions/services/questions-form.service';
import { LabPassDataSourceService } from './services/lab-pass.datasource.service';

@Component({
  selector: 'app-lab-pass',
  templateUrl: './lab-pass.component.html',
  styleUrls: ['./lab-pass.component.scss'],
  providers: [
    LabPassRepositoryService,
    QuestionsFormService,
    LabPassDataSourceService,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LabPassComponent {
  constructor(public repository: LabPassRepositoryService) {}
}
